import type { GetImportRequestsVerificationParams } from 'services/import-requests/types'

export const ImportRequestQueryKeys = {
  All: () => ['import-requests'],
  Labels: () => [...ImportRequestQueryKeys.All(), 'labels'],
  Verification: (requestId: string) => [...ImportRequestQueryKeys.All(), 'verification', requestId],
  VerificationList: (params: GetImportRequestsVerificationParams) => [
    ...ImportRequestQueryKeys.All(),
    'verification-list',
    params
  ],
  FilterLabels: () => [...ImportRequestQueryKeys.All(), 'filter-labels'],
  FilterUsers: () => [...ImportRequestQueryKeys.All(), 'filter-users'],
  FilterAssignees: () => [...ImportRequestQueryKeys.All(), 'filter-assignees'],
  FilterWorkspaces: () => [...ImportRequestQueryKeys.All(), 'filter-workspaces'],
  AssignableAssignees: (requestId: string) => [...ImportRequestQueryKeys.All(), 'assignable-assignees', requestId]
}
